import { useTranslation } from 'modules/domains/list';
import { isNotNull } from 'utils/tsHelpers';
import { CellProps } from './types';
import { NotAvailableLabel, StyledTableCell } from './styles';
import { LIST_COLUMNS } from '../../types';

export const UsersCell = ({ row: list }: CellProps) => {
  const { t } = useTranslation();
  return (
    <StyledTableCell>
      {isNotNull(list.size) ? (
        list.size
      ) : (
        <NotAvailableLabel>
          {t(`indexPage.table.columns.${LIST_COLUMNS.users}.notAvailable`)}
        </NotAvailableLabel>
      )}
    </StyledTableCell>
  );
};
